export class VatIdValidations {
    public static formats = [
        {
            countryCode: 'GBR', pattern: '^(GB|gb|Gb|gB.*$) ?[0-9]{9}', maskFormat: 'SS 000000000',
            minLength: 11, defaultFormat: 'GB 12XXXXXXX'
        },
        {
            countryCode: 'ILN', pattern: '(^.*GB|gb|Gb|gB.*$)?[0-9]{9}', maskFormat: 'SS 000000000',
            minLength: 11, defaultFormat: 'GB 12XXXXXXX'
        },
        {
            countryCode: 'IRL',
            pattern: '^(((IE|ie|Ie|iE)[0-9]{7}[a-zA-Z]{1})|((IE|ie|Ie|iE)[0-9]{7}[a-zA-Z]{2})|((IE|ie|Ie|iE)[0-9]{1}[a-zA-Z]{1}[0-9]{5}[a-zA-Z]{1}))*$',
            maskFormat: 'SS 0A00000SS', minLength: 10, defaultFormat: 'IE XXXXXXXIR'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/vatid-validations.constants.ts